export enum GrievanceNotificationEnum {
    SRAGSindromeRespiratoriaAguaGrave = 1,
    AcidenteDeTrabalhoComExposicaoAMeterialBiologico = 2,
    AtendimentoAntiRabicoHumano = 3,
    AcidentesPorAnimaisPeconhentos = 4,
    TranstornosMentaisRelacionadosAoTrabalho = 5,
    ViolenciaInterpessoalAutoprovocada = 6,
    AcidenteDeTrabalho = 7,
    FebreAmarela = 8,
    DengueEFebreDeChikungunya = 9,
    Rotavirus = 10,
    Meningite = 11,
    IntoxicacaoExogena = 12,
    TetanoAcidental = 13,
    Tuberculose = 15,
    Aids = 14,
    Influenza = 16,
    SRARCSindromeRespiratoriaAgudaRelacionadaACovid = 17,
    SifilisCongenita = 18,
    SifilisAdquirida = 19
}